const CLOUDINARY_BASE_URL = 'https://images.invitationhomes.com/invh-web';

export const FRAUD_AWARENESS_BANNER_DESKTOP_IMAGE = `${CLOUDINARY_BASE_URL}/f_auto,q_auto/website-assets/Fraud_Pic_-_Horizontal_banner_-_Desktop.png`;

export const FRAUD_AWARENESS_BANNER_MOBILE_IMAGE = `${CLOUDINARY_BASE_URL}/f_auto,q_auto/website-assets/Fraud_Pic_-_Vertical_banner_-_Mobile.png`;

export const FRAUD_AWARENESS_BANNER_IH_LOGO_IMAGE = `${CLOUDINARY_BASE_URL}/f_auto,q_auto/website-assets/IH-Blossom-350.png`;
